const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Compression & Rarefaction ─────────────────────────
function DiagramSoundWave() {
  const W = 860, H = 320;

  // Generate molecule positions with compression/rarefaction pattern
  // Sound travels left to right; speaker on left
  const molecules = [];
  // Phase pattern: compression zones at x~300, x~560; rarefaction at x~180, x~430, x~680
  for (let row = 0; row < 5; row++) {
    const baseY = 80 + row * 34;
    for (let col = 0; col < 30; col++) {
      const baseX = 130 + col * 24;
      // Displacement: simulate longitudinal wave
      const phase = (col / 30) * Math.PI * 4;
      const dx = 10 * Math.sin(phase);
      const x = baseX + dx;
      const y = baseY;
      // Density (compression vs rarefaction) drives color
      const density = 0.5 + 0.5 * Math.sin(phase + Math.PI / 2);
      molecules.push({ x, y, density });
    }
  }

  // Wave curve at bottom for reference
  const wavePts = [];
  for (let x = 0; x <= 700; x += 4) {
    const y = 270 + 28 * Math.sin((x / 700) * Math.PI * 4);
    wavePts.push(`${x + 120},${y}`);
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Sound Wave — Compression and Rarefaction of Air Molecules</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="arrowBlk" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 7 3.5, 0 7" fill="#333" />
          </marker>
          <marker id="arrowRed" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 7 3.5, 0 7" fill="#c0392b" />
          </marker>
        </defs>

        {/* Speaker */}
        <polygon points="30,100 70,120 70,220 30,240" fill="#888" stroke="#555" strokeWidth="1.5" />
        <polygon points="70,120 110,90 110,250 70,220" fill="#bbb" stroke="#555" strokeWidth="1.5" />
        <rect x={10} y={95} width={22} height={150} rx={4} fill="#999" stroke="#555" strokeWidth="1.5" />

        {/* Molecules */}
        {molecules.map((m, i) => {
          const r = 7;
          const blue = Math.round(100 + m.density * 120);
          const fill = m.density > 0.6
            ? `rgb(20,60,${blue})`
            : m.density > 0.4
              ? `rgb(80,120,200)`
              : `rgb(140,170,220)`;
          return (
            <circle key={i} cx={m.x} cy={m.y} r={r}
              fill={fill} stroke="#1a3a6e" strokeWidth="0.8" opacity="0.85" />
          );
        })}

        {/* Compression label */}
        <line x1={348} y1={32} x2={330} y2={60} stroke="#c0392b" strokeWidth="1.5" markerEnd="url(#arrowRed)" />
        <text x={355} y={28} fontSize="12" fontWeight="700" fill="#c0392b">Compression</text>

        {/* Rarefaction label */}
        <line x1={220} y1={32} x2={210} y2={60} stroke="#2E75B6" strokeWidth="1.5" markerEnd="url(#arrowRed)" />
        <text x={150} y={28} fontSize="12" fontWeight="700" fill="#2E75B6">Rarefaction</text>

        {/* Direction arrow */}
        <line x1={760} y1={175} x2={840} y2={175} stroke="#333" strokeWidth="2" markerEnd="url(#arrowBlk)" />
        <text x={762} y={168} fontSize="10" fill="#333">Direction of</text>
        <text x={762} y={180} fontSize="10" fill="#333">propagation</text>

        {/* Reference sine wave */}
        <path d={'M ' + wavePts.join(' L ')} fill="none" stroke="#c0392b" strokeWidth="2" opacity="0.7" />
        <text x={120} y={308} fontSize="10" fill="#c0392b" fontStyle="italic">Pressure variation (longitudinal wave representation)</text>
      </svg>
      <div style={S.dCaption}>
        Sound is a longitudinal wave — molecules oscillate parallel to the direction of travel, creating alternating regions of high pressure (compression) and low pressure (rarefaction).
      </div>
    </div>
  );
}

// ── Diagram 2: Wave Properties ────────────────────────────────────
function DiagramWaveProperties() {
  const W = 860, H = 300;

  const pts1 = [], pts2 = [];
  for (let x = 0; x <= 700; x += 3) {
    pts1.push(`${x + 80},${110 + 65 * Math.sin((x / 700) * Math.PI * 4)}`);
    pts2.push(`${x + 80},${220 + 30 * Math.sin((x / 700) * Math.PI * 8)}`);
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Wave Properties — Amplitude, Wavelength, Frequency and Period</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="arrD" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b" />
          </marker>
          <marker id="arrL" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto-start-reverse">
            <polygon points="6 0, 0 3.5, 6 7" fill="#27ae60" />
          </marker>
          <marker id="arrR" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#27ae60" />
          </marker>
        </defs>

        {/* Wave 1 — large amplitude, low frequency */}
        <text x={82} y={18} fontSize="11" fontWeight="700" fill="#1a1a2e">Low frequency, large amplitude (loud, low pitch)</text>
        <line x1={80} y1={110} x2={780} y2={110} stroke="#ddd" strokeWidth="1" strokeDasharray="4,3" />
        <path d={'M ' + pts1.join(' L ')} fill="none" stroke="#2E75B6" strokeWidth="2.5" />

        {/* Amplitude arrow */}
        <line x1={255} y1={110} x2={255} y2={45} stroke="#c0392b" strokeWidth="1.5" markerEnd="url(#arrD)" />
        <text x={260} y={70} fontSize="10" fill="#c0392b" fontWeight="700">Amplitude (A)</text>
        <text x={260} y={83} fontSize="9" fill="#c0392b">(loudness)</text>

        {/* Wavelength arrow — wave 1 */}
        <line x1={80} y1={132} x2={255} y2={132} stroke="#27ae60" strokeWidth="1.5"
          markerStart="url(#arrL)" markerEnd="url(#arrR)" />
        <text x={148} y={148} fontSize="10" fill="#27ae60" fontWeight="700" textAnchor="middle">λ (wavelength)</text>

        {/* Wave 2 — small amplitude, high frequency */}
        <text x={82} y={175} fontSize="11" fontWeight="700" fill="#1a1a2e">High frequency, small amplitude (quiet, high pitch)</text>
        <line x1={80} y1={220} x2={780} y2={220} stroke="#ddd" strokeWidth="1" strokeDasharray="4,3" />
        <path d={'M ' + pts2.join(' L ')} fill="none" stroke="#e67e22" strokeWidth="2.5" />

        {/* Period label */}
        <line x1={80} y1={280} x2={167} y2={280} stroke="#9b59b6" strokeWidth="1.5"
          markerStart="url(#arrL)" markerEnd="url(#arrR)" />
        <text x={123} y={295} fontSize="10" fill="#9b59b6" fontWeight="700" textAnchor="middle">T (period)</text>
      </svg>
      <div style={S.dCaption}>
        Amplitude determines loudness (energy); frequency determines pitch. A higher frequency wave has shorter wavelength and smaller period. The two waves above travel at the same speed — only their shape differs.
      </div>
    </div>
  );
}

// ── Diagram 3: Decibel Scale ──────────────────────────────────────
function DiagramDecibelScale() {
  const W = 860, H = 360;
  const levels = [
    { dB: 0,   label: 'Threshold of hearing',  color: '#27ae60', example: '0 dB' },
    { dB: 10,  label: 'Rustling leaves',        color: '#2ecc71', example: '10 dB' },
    { dB: 30,  label: 'Quiet library',          color: '#f1c40f', example: '30 dB' },
    { dB: 60,  label: 'Normal conversation',    color: '#e67e22', example: '60 dB' },
    { dB: 85,  label: 'Heavy traffic',          color: '#e74c3c', example: '85 dB' },
    { dB: 110, label: 'Rock concert',           color: '#c0392b', example: '110 dB' },
    { dB: 130, label: 'Threshold of pain',      color: '#922b21', example: '130 dB' },
    { dB: 160, label: 'Rocket engine (nearby)', color: '#641e16', example: '160 dB' },
  ];
  const maxdB = 160;
  const barMaxW = 560;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>The Decibel Scale — Sound Intensity Levels</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <text x={430} y={18} textAnchor="middle" fontSize="11" fill="#555" fontStyle="italic">
          Each +10 dB represents a 10× increase in intensity (power), perceived as roughly twice as loud
        </text>
        {levels.map((lv, i) => {
          const barW = (lv.dB / maxdB) * barMaxW;
          const y = 30 + i * 38;
          return (
            <g key={i}>
              <rect x={170} y={y + 4} width={barW || 4} height={24} rx={3} fill={lv.color} opacity="0.85" />
              <text x={165} y={y + 21} fontSize="11" textAnchor="end" fill="#333">{lv.label}</text>
              <text x={176 + (barW || 4)} y={y + 21} fontSize="11" fontWeight="700" fill={lv.color}>{lv.example}</text>
            </g>
          );
        })}
        {/* Axis */}
        <line x1={170} y1={28} x2={170} y2={340} stroke="#aaa" strokeWidth="1.5" />
        {[0, 40, 80, 120, 160].map(v => {
          const x = 170 + (v / maxdB) * barMaxW;
          return (
            <g key={v}>
              <line x1={x} y1={328} x2={x} y2={340} stroke="#aaa" strokeWidth="1" />
              <text x={x} y={355} textAnchor="middle" fontSize="10" fill="#555">{v} dB</text>
            </g>
          );
        })}
        <text x={450} y={355} textAnchor="middle" fontSize="10" fill="#555">Sound Intensity Level (dB)</text>

        {/* Danger zone */}
        <rect x={170 + (85 / 160) * barMaxW} y={28} width={barMaxW - (85 / 160) * barMaxW} height={300}
          fill="#c0392b" opacity="0.06" />
        <text x={170 + (115 / 160) * barMaxW} y={48} textAnchor="middle" fontSize="10" fill="#c0392b" fontWeight="700">⚠ Hearing damage risk</text>
      </svg>
      <div style={S.dCaption}>
        The decibel scale is logarithmic. A difference of 3 dB doubles the power; 10 dB doubles the perceived loudness. Prolonged exposure above 85 dB causes permanent hearing damage.
      </div>
    </div>
  );
}

// ── Diagram 4: Doppler Effect ─────────────────────────────────────
function DiagramDoppler() {
  const W = 860, H = 300;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>The Doppler Effect — Apparent Frequency Change Due to Motion</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="arrBlk2" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 7 3.5, 0 7" fill="#333" />
          </marker>
        </defs>

        {/* Stationary source — left panel */}
        <rect x={20} y={20} width={380} height={260} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5" />
        <text x={210} y={44} textAnchor="middle" fontSize="13" fontWeight="700" fill="#2E75B6">Stationary Source</text>
        {/* Concentric circles */}
        {[30, 60, 90, 120].map((r, i) => (
          <circle key={i} cx={210} cy={155} r={r} fill="none" stroke="#2E75B6"
            strokeWidth="1.8" opacity={1 - i * 0.18} />
        ))}
        {/* Source dot */}
        <circle cx={210} cy={155} r={10} fill="#2E75B6" />
        <text x={210} y={159} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">S</text>
        <text x={210} y={270} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Equal spacing — same frequency in all directions</text>

        {/* Moving source — right panel */}
        <rect x={440} y={20} width={400} height={260} rx={8} fill="#fff5f5" stroke="#c0392b" strokeWidth="1.5" />
        <text x={640} y={44} textAnchor="middle" fontSize="13" fontWeight="700" fill="#c0392b">Moving Source (→)</text>
        {/* Compressed wavefronts ahead, stretched behind */}
        {[22, 44, 66, 90].map((r, i) => (
          <ellipse key={i} cx={600 + i * 10} cy={155} rx={r * 0.65} ry={r}
            fill="none" stroke="#c0392b" strokeWidth="1.8" opacity={1 - i * 0.18} />
        ))}
        {/* Source dot — shifted forward */}
        <circle cx={620} cy={155} r={10} fill="#c0392b" />
        <text x={620} y={159} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">S</text>
        {/* Velocity arrow */}
        <line x1={634} y1={155} x2={670} y2={155} stroke="#333" strokeWidth="2" markerEnd="url(#arrBlk2)" />
        <text x={672} y={151} fontSize="10" fill="#333" fontWeight="700">v</text>
        {/* Labels */}
        <text x={510} y={180} textAnchor="middle" fontSize="10" fill="#c0392b" fontWeight="700">Higher f</text>
        <text x={510} y={193} textAnchor="middle" fontSize="10" fill="#c0392b">(compressed)</text>
        <text x={760} y={180} textAnchor="middle" fontSize="10" fill="#2E75B6" fontWeight="700">Lower f</text>
        <text x={760} y={193} textAnchor="middle" fontSize="10" fill="#2E75B6">(stretched)</text>
        <text x={640} y={270} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Observer ahead hears higher pitch; behind hears lower pitch</text>
      </svg>
      <div style={S.dCaption}>
        The Doppler effect explains why a passing ambulance siren rises in pitch as it approaches and falls as it recedes. The same principle is used in radar speed guns, medical ultrasound, and measuring the recession of galaxies (redshift).
      </div>
    </div>
  );
}

// ── Diagram 5: Standing Waves & Harmonics ─────────────────────────
function DiagramStandingWaves() {
  const W = 860, H = 380;

  function standingWave(n, yBase, L = 680, amp = 35) {
    const pts = [];
    for (let x = 0; x <= L; x += 4) {
      const y = yBase + amp * Math.sin((n * Math.PI * x) / L);
      pts.push(`${x + 90},${y}`);
    }
    return 'M ' + pts.join(' L ');
  }

  const harmonics = [
    { n: 1, label: '1st Harmonic (Fundamental)', freq: 'f₁ = v / 2L', nodes: 2 },
    { n: 2, label: '2nd Harmonic (1st Overtone)', freq: 'f₂ = 2f₁',   nodes: 3 },
    { n: 3, label: '3rd Harmonic (2nd Overtone)', freq: 'f₃ = 3f₁',   nodes: 4 },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Standing Waves and Harmonics in a String Fixed at Both Ends</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        {harmonics.map((h, i) => {
          const yBase = 65 + i * 115;
          const L = 680;
          return (
            <g key={i}>
              {/* String baseline */}
              <line x1={90} y1={yBase} x2={90 + L} y2={yBase} stroke="#bbb" strokeWidth="1.5" strokeDasharray="4,3" />
              {/* Standing wave */}
              <path d={standingWave(h.n, yBase, L, 38)} fill="none" stroke="#2E75B6" strokeWidth="2.5" />
              {/* Mirror (lower half) */}
              <path d={standingWave(h.n, yBase, L, -38)} fill="none" stroke="#2E75B6" strokeWidth="2.5" opacity="0.4" />
              {/* Fixed endpoints */}
              <circle cx={90} cy={yBase} r={5} fill="#7B0D0D" />
              <circle cx={90 + L} cy={yBase} r={5} fill="#7B0D0D" />
              {/* Nodes */}
              {Array.from({ length: h.n + 1 }).map((_, ni) => {
                const nx = 90 + (ni / h.n) * L;
                return <circle key={ni} cx={nx} cy={yBase} r={4} fill="#c0392b" opacity="0.8" />;
              })}
              {/* Label */}
              <text x={82} y={yBase - 42} fontSize="11" fontWeight="700" fill="#1a1a2e">{h.label}</text>
              <text x={82} y={yBase - 29} fontSize="10" fill="#c0392b" fontFamily="'Courier New', monospace">{h.freq}</text>
              <text x={82} y={yBase - 16} fontSize="10" fill="#555">Nodes: {h.nodes}  |  Antinodes: {h.n}</text>
            </g>
          );
        })}
        {/* Node legend */}
        <circle cx={90} cy={355} r={5} fill="#c0392b" opacity="0.8" />
        <text x={100} y={360} fontSize="10" fill="#333">Node (zero displacement)</text>
        <text x={300} y={360} fontSize="10" fill="#2E75B6" fontWeight="700">■</text>
        <text x={312} y={360} fontSize="10" fill="#333">Antinode (maximum displacement)</text>
      </svg>
      <div style={S.dCaption}>
        A standing wave forms when a wave reflects back on itself and interferes constructively. Only certain frequencies (harmonics) produce stable standing waves — determined by the length and wave speed. This is how stringed instruments and organ pipes produce musical notes.
      </div>
    </div>
  );
}

// ── Diagram 6: Reflection, Refraction, Diffraction ───────────────
function DiagramBehaviours() {
  const W = 860, H = 300;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Sound Wave Behaviours — Reflection, Refraction and Diffraction</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>

        {/* ── Reflection ── */}
        <rect x={15} y={15} width={250} height={270} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5" />
        <text x={140} y={38} textAnchor="middle" fontSize="13" fontWeight="700" fill="#2E75B6">Reflection</text>
        {/* Wall */}
        <rect x={220} y={50} width={18} height={200} rx={2} fill="#aaa" />
        {/* Incident rays */}
        {[80, 110, 140].map((y, i) => (
          <line key={i} x1={40} y1={y} x2={218} y2={y + (i - 1) * 25} stroke="#2E75B6" strokeWidth="1.8"
            markerEnd="url(#a1)" strokeDasharray={i === 1 ? 'none' : '5,3'} />
        ))}
        {/* Reflected rays */}
        {[105, 135, 165].map((y, i) => (
          <line key={i} x1={218} y1={y} x2={50} y2={y + (i - 1) * 20 + 30} stroke="#c0392b" strokeWidth="1.8"
            markerEnd="url(#a2)" strokeDasharray={i === 1 ? 'none' : '5,3'} />
        ))}
        <text x={140} y={278} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Angle of incidence = angle of reflection</text>

        {/* ── Refraction ── */}
        <rect x={295} y={15} width={260} height={270} rx={8} fill="#fff5f5" stroke="#e67e22" strokeWidth="1.5" />
        <text x={425} y={38} textAnchor="middle" fontSize="13" fontWeight="700" fill="#e67e22">Refraction</text>
        {/* Medium boundary */}
        <line x1={425} y1={50} x2={425} y2={270} stroke="#e67e22" strokeWidth="1.5" strokeDasharray="6,3" />
        <text x={360} y={58} textAnchor="middle" fontSize="9" fill="#e67e22">Medium 1 (slower)</text>
        <text x={495} y={58} textAnchor="middle" fontSize="9" fill="#e67e22">Medium 2 (faster)</text>
        {/* Incident ray */}
        <line x1={310} y1={80} x2={425} y2={160} stroke="#e67e22" strokeWidth="2" markerEnd="url(#a3)" />
        {/* Refracted ray — bends away from normal */}
        <line x1={425} y1={160} x2={535} y2={260} stroke="#e67e22" strokeWidth="2" markerEnd="url(#a3)" />
        {/* Normal */}
        <line x1={425} y1={100} x2={425} y2={260} stroke="#bbb" strokeWidth="1" strokeDasharray="3,3" />
        {/* Angle arcs */}
        <path d="M 425,160 m -30,0 a 30,30 0 0,0 18,-22" fill="none" stroke="#555" strokeWidth="1" />
        <text x={386} y={152} fontSize="9" fill="#555">θ₁</text>
        <path d="M 425,160 m 10,28 a 30,30 0 0,0 20,-8" fill="none" stroke="#555" strokeWidth="1" />
        <text x={452} y={195} fontSize="9" fill="#555">θ₂</text>
        <text x={425} y={278} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Speed change bends the wavefront</text>

        {/* ── Diffraction ── */}
        <rect x={580} y={15} width={265} height={270} rx={8} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.5" />
        <text x={712} y={38} textAnchor="middle" fontSize="13" fontWeight="700" fill="#27ae60">Diffraction</text>
        {/* Barrier with gap */}
        <rect x={685} y={50} width={14} height={80} rx={2} fill="#aaa" />
        <rect x={685} y={180} width={14} height={90} rx={2} fill="#aaa" />
        {/* Incoming parallel waves */}
        {[75, 95, 115, 135, 155].map((y, i) => (
          <line key={i} x1={595} y1={y} x2={683} y2={y} stroke="#27ae60" strokeWidth="1.6" markerEnd="url(#a4)" />
        ))}
        {/* Diffracted semicircular waves */}
        {[18, 36, 54, 72].map((r, i) => (
          <path key={i} d={`M ${699},${135} m ${r},0 a ${r},${r} 0 0,0 -${2*r},0`}
            fill="none" stroke="#27ae60" strokeWidth="1.5" opacity={1 - i * 0.18} />
        ))}
        <text x={712} y={278} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">Waves spread through a narrow gap</text>

        <defs>
          <marker id="a1" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto"><polygon points="0 0,6 3.5,0 7" fill="#2E75B6"/></marker>
          <marker id="a2" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto"><polygon points="0 0,6 3.5,0 7" fill="#c0392b"/></marker>
          <marker id="a3" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto"><polygon points="0 0,6 3.5,0 7" fill="#e67e22"/></marker>
          <marker id="a4" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto"><polygon points="0 0,6 3.5,0 7" fill="#27ae60"/></marker>
        </defs>
      </svg>
      <div style={S.dCaption}>
        Sound obeys the same wave behaviours as light. Diffraction explains why you can hear around corners — sound waves (long wavelength) spread significantly through doorways and openings.
      </div>
    </div>
  );
}

export default function SoundPhysics() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>The Physics of Sound</h1>

      <p style={S.p}>
        Sound is a mechanical, longitudinal wave — a propagating disturbance of pressure through a material medium. Unlike light, sound cannot travel through a vacuum; it requires particles to vibrate and pass energy along. The speed, behaviour, and perception of sound are governed by a rich set of physical laws that explain everything from the resonance of a guitar string to the sonic boom of a supersonic aircraft.
      </p>
      <p style={S.p}>
        Sound is characterised by its <strong>frequency</strong> (determining pitch), <strong>amplitude</strong> (determining loudness), <strong>speed</strong> (determined by the medium), and <strong>waveform</strong> (determining timbre or tone quality). The study of sound — <strong>acoustics</strong> — encompasses musical physics, architectural design, medical imaging, and geophysics.
      </p>
      <p style={S.p}>
        Sound pressure levels reduce with distance due to the inverse square law, absorption by the medium, and scattering from obstacles. The human ear detects frequencies between approximately 20 Hz and 20,000 Hz; below this range is infrasound, above it is ultrasound — both with important scientific and medical applications.
      </p>

      <InfoBox title="What This Page Covers" items={[
        "Nature of sound: longitudinal waves, compression and rarefaction",
        "Wave properties: amplitude, frequency, wavelength, period, speed",
        "The decibel scale and sound intensity",
        "The Doppler effect and its applications",
        "Standing waves, resonance, and harmonics",
        "Reflection, refraction, diffraction, and superposition",
        "Speed of sound in different media",
        "Interference, beats, and acoustic phenomena",
        "Ultrasound and infrasound applications",
        "Musical acoustics: strings, pipes, and resonance",
      ]}/>

      <h2 style={S.h2}>Nature of Sound — A Longitudinal Wave</h2>
      <p style={S.p}>
        Sound is produced when a vibrating object causes the surrounding medium to oscillate. In air, the speaker cone pushes air molecules together (compression) and then pulls back, leaving a region of lower pressure (rarefaction). These pressure disturbances travel outward as a <strong>longitudinal wave</strong> — meaning the particle displacement is parallel to the direction of energy transfer, unlike transverse waves (e.g. light) where displacement is perpendicular.
      </p>
      <DiagramSoundWave/>
      <Table2 rows={[
        ["Longitudinal wave","Particle oscillation is parallel to wave propagation direction\nContrast: transverse waves (strings, EM waves) oscillate perpendicularly"],
        ["Compression","Region where molecules are closer together → higher pressure than ambient\nCorresponds to the crest of the equivalent pressure–displacement graph"],
        ["Rarefaction","Region where molecules are further apart → lower pressure than ambient\nCorresponds to the trough of the pressure–displacement graph"],
        ["Medium required","Sound cannot travel through a vacuum — confirmed by bell-in-jar experiment\nTravels through solids, liquids, and gases; fastest in solids"],
        ["Sound as energy","Sound carries energy but not matter — molecules oscillate about fixed mean positions\nEnergy flux = intensity (W/m²)"],
        ["Audible range","Human hearing: ~20 Hz – 20,000 Hz\nInfrasound < 20 Hz (earthquakes, elephants); Ultrasound > 20 kHz (bats, medical imaging)"],
      ]}/>

      <h2 style={S.h2}>Wave Properties</h2>
      <p style={S.p}>
        Every sound wave is described by four key measurable properties: amplitude, frequency, wavelength, and speed. These are related by the wave equation and together determine how the sound is perceived and how it behaves in different environments.
      </p>
      <DiagramWaveProperties/>
      <Table2 rows={[
        ["Amplitude (A)","Maximum displacement of a particle from its equilibrium position (metres)\nDetermines loudness — energy ∝ A²; doubling amplitude quadruples intensity"],
        ["Frequency (f)","Number of complete oscillations per second; unit: Hertz (Hz)\nDetermines pitch — higher f = higher pitch"],
        ["Period (T)","Time for one complete oscillation: T = 1/f  (seconds)\nA 440 Hz concert A has T = 2.27 ms"],
        ["Wavelength (λ)","Distance between two successive compressions (or rarefactions)\nλ = v/f  — at 340 m/s, 440 Hz gives λ ≈ 0.77 m"],
        ["Wave equation","v = fλ\nv = speed of sound in medium (m/s), f = frequency (Hz), λ = wavelength (m)"],
        ["Angular frequency","ω = 2πf  (radians per second)\nUsed in the wave equation: y(x,t) = A sin(kx − ωt)"],
        ["Wave number","k = 2π/λ  (radians per metre)\nSpatial frequency — how rapidly the wave oscillates per unit distance"],
        ["Phase","Describes the position within a cycle: y = A sin(ωt + φ)\nTwo waves with phase difference φ = π are in anti-phase and cancel"],
      ]}/>

      <h2 style={S.h2}>Speed of Sound</h2>
      <p style={S.p}>
        The speed of sound depends on the <strong>elasticity</strong> (restoring force) and <strong>inertia</strong> (density) of the medium — not on the frequency or amplitude of the wave. Sound travels fastest in stiff, dense solids and slowest in gases. In air, temperature has a significant effect: warmer air is less dense and more elastic, increasing wave speed.
      </p>
      <Table2 rows={[
        ["Speed in air (20 °C)","v ≈ 343 m/s  (~1235 km/h, ~1 mile in 4.7 seconds)\nGeneral rule: v ≈ 331 + 0.6T  m/s  (T in °C)"],
        ["Speed in water","v ≈ 1480 m/s  (≈ 4.3× faster than in air)\nHigher bulk modulus — water is much less compressible than air"],
        ["Speed in steel","v ≈ 5960 m/s  (≈ 17× faster than in air)\nHigh Young's modulus; used in seismology and rail fault detection"],
        ["General formula (fluid)","v = √(B/ρ)\nB = bulk modulus (Pa), ρ = density (kg/m³)"],
        ["General formula (solid, longitudinal)","v = √(E/ρ)\nE = Young's modulus, ρ = density"],
        ["Effect of temperature","Higher T → lower ρ → higher v (in gases)\nv ∝ √T  (T in Kelvin); explains refraction of sound in atmosphere"],
        ["Mach number","M = v_object / v_sound\nM > 1: supersonic; M = 1: sonic boom; M > 5: hypersonic"],
        ["Sonic boom","Shock wave formed when object exceeds sound speed\nWavefronts pile up into a cone (Mach cone); angle: sin θ = 1/M"],
      ]}/>

      <h2 style={S.h2}>Intensity and the Decibel Scale</h2>
      <p style={S.p}>
        Sound intensity is the power transmitted per unit area, measured in W/m². Because the human ear responds to an enormous range — from the threshold of hearing at 10⁻¹² W/m² to the pain threshold at ~1 W/m² — a logarithmic scale (the <strong>decibel</strong>) is used to express intensity levels in a manageable way.
      </p>
      <DiagramDecibelScale/>
      <Table2 rows={[
        ["Intensity (I)","Power per unit area: I = P / (4πr²)  (point source, W/m²)\nInverse square law — doubling distance quarters intensity"],
        ["Intensity level (β)","β = 10 log₁₀(I / I₀)  dB\nI₀ = 10⁻¹² W/m² (threshold of hearing)"],
        ["+3 dB","Doubles the power/intensity\nSmallest difference most people can detect"],
        ["+10 dB","10× increase in intensity; perceived as ~2× louder\nA conversation (60 dB) is 10× more intense than a quiet library (50 dB)"],
        ["+20 dB","100× increase in intensity; perceived as ~4× louder"],
        ["Sound power (W)","Total acoustic power emitted by a source, regardless of distance\nA whisper ≈ 10⁻⁹ W; a jet engine ≈ 100 kW"],
        ["Inverse square law","I ∝ 1/r² for a point source in a free field\nDoubly useful: predicts both spreading loss and echo timing"],
        ["Hearing damage","Prolonged exposure > 85 dB damages hair cells in cochlea (permanent)\nNoise-induced hearing loss is the most common occupational injury worldwide"],
      ]}/>

      <h2 style={S.h2}>The Doppler Effect</h2>
      <p style={S.p}>
        When a source of sound and an observer are in relative motion, the observed frequency differs from the emitted frequency. This is the <strong>Doppler effect</strong>. As the source approaches, wavefronts are compressed, increasing the observed frequency (higher pitch). As it recedes, wavefronts are stretched, decreasing frequency (lower pitch). The effect applies whenever there is relative motion between source and observer.
      </p>
      <DiagramDoppler/>
      <Table2 rows={[
        ["Observed frequency","f_obs = f_s × (v ± v_o) / (v ∓ v_s)\nv = speed of sound, v_s = source speed, v_o = observer speed\nUpper signs: approaching; lower signs: receding"],
        ["Source approaching observer","f_obs = f_s × v / (v − v_s)  →  f_obs > f_s"],
        ["Source receding from observer","f_obs = f_s × v / (v + v_s)  →  f_obs < f_s"],
        ["Observer moving toward source","f_obs = f_s × (v + v_o) / v"],
        ["Radar speed guns","Microwaves reflect off moving vehicle; Doppler shift gives speed\nv_vehicle = (Δf / f) × c / 2  (factor of 2 for round trip)"],
        ["Medical ultrasound","Doppler ultrasound measures blood flow velocity\nShift in 5–15 MHz probe signal indicates flow speed and direction"],
        ["Astronomical redshift","Recession of galaxies shifts spectral lines toward longer wavelengths\nHubble Law: recession speed v = H₀ × d (H₀ ≈ 70 km/s/Mpc)"],
        ["Sonic boom","When v_s = v, wavefronts stack up — pressure builds dramatically\nWhen v_s > v, a Mach cone shock wave trails the object"],
      ]}/>

      <h2 style={S.h2}>Reflection and Echoes</h2>
      <p style={S.p}>
        When sound meets a boundary between two media, part of the energy is reflected and part is transmitted (and refracted). The law of reflection applies: angle of incidence equals angle of reflection, measured from the normal to the surface. Reflection is the basis of sonar, echolocation, and architectural acoustics.
      </p>
      <Table2 rows={[
        ["Law of reflection","θ_i = θ_r  (measured from normal to reflecting surface)\nHolds for all wave types including sound"],
        ["Echo","A reflected sound heard as a distinct repetition of the original\nRequires a reflecting surface > ~17 m away (64 ms delay at 343 m/s)"],
        ["Reverberation","Multiple overlapping reflections cause sound to persist after the source stops\nRT60 = time for sound to decay 60 dB — key metric in room acoustics"],
        ["Acoustic impedance","Z = ρv  (kg/m²·s)\nReflection coefficient r = (Z₂−Z₁)²/(Z₂+Z₁)² — mismatch = more reflection"],
        ["Sonar","Sound Navigation And Ranging: depth = v × t / 2\nActive sonar: emits pulse; passive sonar: listens only"],
        ["Echolocation","Bats emit 20–200 kHz ultrasound pulses; locate prey by echo timing\nDolphins use 40–150 kHz; resolution ~1 mm at close range"],
        ["Ultrasonic testing (NDT)","Sound pulses reflect from cracks or voids in materials\nUsed to inspect welds, aircraft wings, pipelines without disassembly"],
      ]}/>

      <h2 style={S.h2}>Refraction and Diffraction</h2>
      <DiagramBehaviours/>
      <Table2 rows={[
        ["Refraction","Sound bends when it crosses a boundary where speed changes\nSnell's Law: sin θ₁ / v₁ = sin θ₂ / v₂"],
        ["Atmospheric refraction","Sound bends downward at night (cooler air near ground = slower speed)\nExplains why sounds carry further at night"],
        ["Temperature inversion","Warm air above cool air can cause a refracting 'sound duct'\nExplains anomalous long-distance propagation of explosions and thunder"],
        ["Diffraction","Waves spread around obstacles and through openings\nSignificant when λ ≈ gap size; explains why bass carries around corners"],
        ["Diffraction at doorway","A 100 Hz sound (λ = 3.4 m) diffracts strongly through a 1 m doorway\nA 10 kHz sound (λ = 3.4 cm) barely diffracts — directional"],
        ["Scattering","Reflection in many directions from irregular surfaces or particles\nFog horns scatter; soft furnishings scatter and absorb in rooms"],
      ]}/>

      <h2 style={S.h2}>Superposition and Interference</h2>
      <p style={S.p}>
        When two or more sound waves occupy the same region of space simultaneously, the <strong>principle of superposition</strong> states that the resultant displacement at any point is the algebraic sum of the individual displacements. This leads to constructive interference (louder) and destructive interference (quieter or silent), and is the basis of standing waves, beats, and noise-cancelling technology.
      </p>
      <Table2 rows={[
        ["Principle of superposition","y_total = y₁ + y₂ + ...\nDisplacements add algebraically at every point and instant"],
        ["Constructive interference","Waves in phase (Δφ = 0, 2π, 4π, ...): amplitudes add\nPath difference = nλ → maximum loudness"],
        ["Destructive interference","Waves in anti-phase (Δφ = π, 3π, ...): amplitudes cancel\nPath difference = (n+½)λ → silence"],
        ["Beats","Two similar frequencies f₁ and f₂ interfere: beat frequency = |f₁ − f₂|\nUsed to tune musical instruments — beat rate falls to zero when in tune"],
        ["Active noise cancellation","Microphone detects noise; electronics generate anti-phase wave\nDestructive interference reduces unwanted sound by 20–40 dB"],
        ["Two-source interference","Constructive: d sinθ = nλ  (n = 0, 1, 2, ...)\nDestructive: d sinθ = (n+½)λ  (d = source separation)"],
      ]}/>

      <h2 style={S.h2}>Standing Waves and Resonance</h2>
      <p style={S.p}>
        A standing wave forms when a progressive wave reflects back on itself and the two travelling waves interfere. At <strong>nodes</strong> the displacement is always zero; at <strong>antinodes</strong> the displacement is maximum. Standing waves only form at specific frequencies (harmonics) — this is <strong>resonance</strong>. Resonance is the physical basis of all musical instruments.
      </p>
      <DiagramStandingWaves/>
      <Table2 rows={[
        ["Node","Point of zero displacement in a standing wave\nOccurs where two waves always cancel: path difference causes permanent anti-phase"],
        ["Antinode","Point of maximum displacement\nOccurs midway between nodes; displacement oscillates between ±A"],
        ["Fundamental frequency","Lowest resonant frequency: f₁ = v / 2L  (string fixed both ends)\nCorresponds to one half-wavelength fitting in the length L"],
        ["Harmonics (string)","fₙ = n × f₁  (n = 1, 2, 3, ...)\nAll integer multiples present in a plucked string — determines timbre"],
        ["Open pipe","Both ends open: antinodes at both ends\nf₁ = v/2L; all harmonics present (same as string)"],
        ["Closed pipe","One end closed (node), one open (antinode)\nf₁ = v/4L; only odd harmonics present: f₁, 3f₁, 5f₁, ..."],
        ["Resonance condition","Driving frequency matches natural frequency → large amplitude build-up\nExamples: Tacoma Narrows bridge, wine glass shattering, MRI"],
        ["Quality factor (Q)","Q = f_resonant / bandwidth — measures sharpness of resonance\nHigh Q: narrow, tall peak; sharply tuned (e.g. tuning fork Q ~ 1000)"],
      ]}/>

      <h2 style={S.h2}>Musical Acoustics</h2>
      <p style={S.p}>
        Musical instruments produce sound through resonance. A vibrating string, air column, or membrane drives standing waves at specific harmonic frequencies. The blend of harmonics present — the <strong>harmonic spectrum</strong> — gives each instrument its characteristic timbre or tone colour, even when playing the same pitch.
      </p>
      <Table2 rows={[
        ["Stringed instruments","Plucked/bowed string vibrates at f₁ and harmonics\nFrequency tuned by tension (T), length (L), mass per unit length (μ): f₁ = (1/2L)√(T/μ)"],
        ["Wind instruments (open)","Air column resonates with antinodes at both open ends\nFlute, recorder: f₁ = v/2L; all harmonics present"],
        ["Wind instruments (closed)","Clarinet: one closed end → f₁ = v/4L; odd harmonics only\nGives clarinet its distinctive hollow timbre vs flute"],
        ["Percussion","Membranes and bars have non-harmonic overtone series\nExplains why a drum has less defined pitch than a trumpet"],
        ["Timbre","The harmonic content (relative strengths of f₁, f₂, f₃...) gives tone colour\nA Fourier transform of a sound shows which harmonics are present"],
        ["Equal temperament","Each octave divided into 12 equal semitones: ratio = 2^(1/12) ≈ 1.0595\nStandard tuning since ~18th century; all intervals slightly impure except octave"],
        ["Concert pitch A","Standard: A4 = 440 Hz (ISO 16)\nHistorically varied 415–466 Hz; orchestras sometimes use 442–444 Hz"],
        ["Acoustic resonance","Hollow body of guitar/violin amplifies resonant frequencies\nTop plate, back plate, and air cavity all have own resonances"],
      ]}/>

      <h2 style={S.h2}>Ultrasound and Infrasound</h2>
      <p style={S.p}>
        Beyond the human audible range, sound waves have powerful scientific, medical, and industrial applications. <strong>Ultrasound</strong> (above 20 kHz) enables non-invasive imaging and cleaning with millimetre precision. <strong>Infrasound</strong> (below 20 Hz) propagates over enormous distances with little absorption and is used to monitor earthquakes, volcanoes, and nuclear tests.
      </p>
      <Table2 rows={[
        ["Medical ultrasound","Probe emits 1–20 MHz pulses; echoes timed to build image\nDepth = v × t / 2  (v ≈ 1540 m/s in soft tissue)"],
        ["Doppler ultrasound","Measures blood flow velocity via frequency shift\nColour Doppler maps flow direction and speed in real time"],
        ["Acoustic impedance matching","Gel applied between probe and skin to minimise reflection at air/skin boundary\nWithout gel: >99% of energy reflected (Z_air << Z_tissue)"],
        ["Ultrasonic cleaning","High-frequency waves create cavitation bubbles that implode\nRemoves contaminants from jewellery, surgical instruments, semiconductors"],
        ["SONAR depth measurement","d = v_water × t / 2  (t = echo return time, v_water ≈ 1480 m/s)\nUsed in bathymetry, submarine detection, fish-finding"],
        ["Infrasound sources","Earthquakes, volcanoes, meteor airbursts, ocean waves, wind\nElephants, whales, and hippos communicate via infrasound over km distances"],
        ["CTBTO monitoring","Comprehensive Test Ban Treaty Organisation: 60 infrasound stations worldwide\nDetects atmospheric nuclear explosions; can locate events to within ~1 km"],
        ["Seismology","P-waves (longitudinal, ~6 km/s in crust) and S-waves (transverse) from earthquakes\nVelocity profiles reveal Earth's internal structure (crust, mantle, core)"],
      ]}/>

      <h2 style={S.h2}>Architectural and Environmental Acoustics</h2>
      <Table2 rows={[
        ["Reverberation time RT60","Time for sound level to fall 60 dB after source stops\nSabine formula: RT60 = 0.161 × V / A  (V = room volume m³, A = total absorption m²)"],
        ["Absorption coefficient","α = 0: perfect reflector; α = 1: perfect absorber\nCarpet: α ≈ 0.35; bare concrete: α ≈ 0.02; acoustic foam: α ≈ 0.8"],
        ["Concert hall design","RT60 ≈ 1.8–2.2 s for orchestral music; ~1.0 s for speech\nConvex surfaces diffuse sound; balconies and side walls add lateral reflections"],
        ["Noise pollution","Unwanted sound measured in dB(A) — A-weighted to match human sensitivity\nUK limit for construction noise: 75 dB(A) at 1 m from façade"],
        ["Sound insulation","Mass law: heavier walls transmit less sound; TL ≈ 20 log₁₀(m·f) − 47  dB\nDouble glazing with air gap reduces transmission by ~40 dB"],
        ["Flanking transmission","Sound bypasses barriers via structure-borne paths (floors, ducts, beams)\nMust be treated separately from airborne insulation"],
        ["Open-plan office","Background noise ~40–50 dB(A) needed to mask speech intelligibility\nSpeech privacy achieved when A-weighted SPL falls below background at 4 m"],
      ]}/>

      <InfoBox title="Key Formulae — Sound Physics" items={[
        "Wave equation: v = fλ  (v in m/s, f in Hz, λ in metres)",
        "Speed in air: v ≈ 331 + 0.6T  m/s  (T = temperature in °C)",
        "Speed in medium: v = √(B/ρ)  for fluids;  v = √(E/ρ)  for solids",
        "Intensity inverse square law: I = P / (4πr²)  (W/m²)",
        "Decibel level: β = 10 log₁₀(I / I₀)  dB  (I₀ = 10⁻¹² W/m²)",
        "Doppler effect: f_obs = f_s × (v ± v_o) / (v ∓ v_s)",
        "Fundamental frequency (string, both ends fixed): f₁ = (1/2L) √(T/μ)",
        "Standing wave harmonics: fₙ = n × v / 2L  (open pipe or fixed string)",
        "Closed pipe (one end): fₙ = (2n−1) × v / 4L  (odd harmonics only)",
        "Beat frequency: f_beat = |f₁ − f₂|",
        "Sabine reverberation: RT60 = 0.161 V / A  (V = volume m³, A = absorption m²)",
        "Acoustic impedance: Z = ρv  (kg/m²s);  reflection coefficient = [(Z₂−Z₁)/(Z₂+Z₁)]²",
      ]}/>
    </div>
  );
}